import { render, staticRenderFns } from "./VFatherPatProfile.vue?vue&type=template&id=e2262b8a"
import script from "./VFatherPatProfile.vue?vue&type=script&lang=js"
export * from "./VFatherPatProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports